export type AspectRatio = 'video' | 'square' | 'classic' | 'cinemaScope';

export const aspectRatioVariants: Record<AspectRatio, string | undefined> = {
  video: 'aspect-video',
  square: 'aspect-square',
  cinemaScope: 'aspect-[21/9]',
  classic: 'aspect-[4/3]'
};
